import { Component } from "solid-js";

interface EntertainmentIconProps {
  class?: string;
}

export const EntertainmentIcon: Component<EntertainmentIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M25.4918 7.99998V24C25.4918 25.4733 24.2985 26.6666 22.8251 26.6666H9.17448C7.70115 26.6666 6.50781 25.4733 6.50781 24V7.99998C6.50781 6.52665 7.70115 5.33331 9.17448 5.33331H22.8265C24.2985 5.33331 25.4918 6.52665 25.4918 7.99998Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.4919 8H27.6279C28.7319 8 29.6279 8.896 29.6279 10V22C29.6279 23.104 28.7319 24 27.6279 24H25.4919"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.50794 24H4.37061C3.26661 24 2.37061 23.104 2.37061 22V10C2.37061 8.896 3.26661 8 4.37061 8H6.50661"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.2052 13.1147L18.8998 15.3C19.4318 15.6147 19.4318 16.3853 18.8998 16.7L15.2052 18.8853C14.6625 19.2067 13.9785 18.8147 13.9785 18.1853V13.8147C13.9785 13.184 14.6638 12.7933 15.2052 13.1147V13.1147Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
